function debounceFunctions<T extends (...args: any[]) => any>(
  func: T,
  wait: number,
) {
  let timeout: ReturnType<typeof setTimeout>;
  return function debouncedFunction(this: any, ...args: Parameters<T>) {
    clearTimeout(timeout);
    return new Promise<ReturnType<T>>((resolve) => {
      timeout = setTimeout(() => resolve(func.apply(this, args)), wait);
    });
  };
}

export default debounceFunctions;
